import { useState, FormEvent } from 'react';
import { useAuth } from '../AuthContext';
import { register, login } from '../api';

export default function RegisterPage() {
  const { setAuth } = useAuth();
  const [inviteCode, setInviteCode] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Register
    const { error: regErr } = await register(inviteCode, email, password, displayName);
    if (regErr) {
      setError(regErr);
      setLoading(false);
      return;
    }

    // Auto-login after registration
    const { data: loginData, error: loginErr } = await login(email, password);
    setLoading(false);

    if (loginErr) {
      setError('Registered successfully but login failed. Please sign in manually.');
      return;
    }

    if (loginData) {
      setAuth(loginData.token, loginData.user);
    }
  }

  return (
    <div className="page">
      <div className="card" style={{ maxWidth: 400, margin: '80px auto' }}>
        <h1>Join AK Pizza Bot</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>Enter your invite code to register</p>

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="inviteCode">Invite Code</label>
            <input
              id="inviteCode"
              type="text"
              value={inviteCode}
              onChange={e => setInviteCode(e.target.value)}
              autoCapitalize="none"
              required
              autoFocus
              placeholder="8-character code"
              maxLength={8}
              style={{ fontFamily: 'monospace', letterSpacing: 2 }}
            />
          </div>

          <div className="field">
            <label htmlFor="name">Display Name</label>
            <input
              id="name"
              type="text"
              value={displayName}
              onChange={e => setDisplayName(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating account...' : 'Register'}
          </button>
        </form>

        <p style={{ marginTop: 16, textAlign: 'center' }}>
          Already have an account? <a href="/login">Sign in</a>
        </p>
      </div>
    </div>
  );
}
